import React, { useState } from 'react'

import {ReactComponent as CheckedIcon}  from 'assets/icons/check-icon.svg'
import { ICheckboxProps } from './CheckboxProps'
import clsx from 'clsx'

import './Checkbox.scss'


/**
 * Komponent checkboxa używany przy zaznaczaniu zgód w aplikacji
*/
const Checkbox = (props: ICheckboxProps): JSX.Element => {

   const [isChecked, setIsChecked] = useState<boolean>(Boolean(props.isChecked))

   const handleOnClick = (e: React.MouseEvent<HTMLDivElement>) => {
      if(props.handleOnClick){
         props.handleOnClick(e)
         return
      }
      else {
         setIsChecked(!Boolean(isChecked))
         return
      }
   }

   return (
      <div 
         className={clsx('app-checkbox-wrapper', props.hasError && 'app-checkbox-has-error', props.className && props.className)} 
         onClick={(e: React.MouseEvent<HTMLDivElement>) => handleOnClick(e)}
      >
         <CheckedIcon className={clsx(props.isChecked ? 'app-checkbox-marked' : 'app-checkbox-unmarked')}/>
      </div>
   )
}

export default Checkbox